import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, isRef as _isRef, vModelRadio as _vModelRadio, withDirectives as _withDirectives, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "radio-group-container w-full" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "input-label" }, [
  /*#__PURE__*/_createTextVNode("Wskazania do przeprowadzenia badań prenatalnych: "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-error" }, "*")
], -1)
const _hoisted_3 = { class: "radio-button form-radio-button" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "checkmark" }, null, -1)
const _hoisted_5 = { class: "radio-button form-radio-button" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "checkmark" }, null, -1)
const _hoisted_7 = { class: "radio-button form-radio-button" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "checkmark" }, null, -1)
const _hoisted_9 = { class: "radio-button form-radio-button" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "checkmark" }, null, -1)
const _hoisted_11 = {
  key: 0,
  class: "error-message"
}

import { useField } from 'vee-validate';
import { RadioGroup, RadioGroupOption } from '@headlessui/vue';


export default {
  __name: 'IndicationsForPrenatalTesting',
  setup(__props) {

const { value, errorMessage } = useField('indicationsForPrenatalTesting');

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_unref(RadioGroup), {
      class: "radio-group radio-group--column w-full !mb-0 !max-w-none",
      modelValue: _unref(value),
      "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => (_isRef(value) ? (value).value = $event : null))
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(RadioGroupOption), {
          class: "cursor-pointer flex items-center justify-start font-medium text-[14px]",
          value: "Wystąpienie w poprzedniej ciąży aberracji chromosomowej płodu."
        }, {
          default: _withCtx(() => [
            _createElementVNode("label", _hoisted_3, [
              _withDirectives(_createElementVNode("input", {
                name: "indicationsForPrenatalTesting",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (_isRef(value) ? (value).value = $event : null)),
                type: "radio",
                value: "1"
              }, null, 512), [
                [_vModelRadio, _unref(value)]
              ]),
              _hoisted_4,
              _createTextVNode(" Wystąpienie w poprzedniej ciąży aberracji chromosomowej płodu. ")
            ])
          ]),
          _: 1
        }),
        _createVNode(_unref(RadioGroupOption), {
          class: "cursor-pointer flex items-center justify-start font-medium text-[14px]",
          value: "Stwierdzenie wystąpienia strukturalnych aberracji chromosomowych u ciężarnej lub ojca dziecka."
        }, {
          default: _withCtx(() => [
            _createElementVNode("label", _hoisted_5, [
              _withDirectives(_createElementVNode("input", {
                name: "indicationsForPrenatalTesting",
                type: "radio",
                value: "2",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (_isRef(value) ? (value).value = $event : null))
              }, null, 512), [
                [_vModelRadio, _unref(value)]
              ]),
              _hoisted_6,
              _createTextVNode(" Stwierdzenie wystąpienia strukturalnych aberracji chromosomowych u ciężarnej lub ojca dziecka. ")
            ])
          ]),
          _: 1
        }),
        _createVNode(_unref(RadioGroupOption), {
          class: "cursor-pointer flex items-center justify-start font-medium text-[14px]",
          value: "Stwierdzenie znacznie większego ryzyka urodzenia dziecka dotkniętego chorobą uwarunkowaną monogenetycznie lub wieloczynnikowo."
        }, {
          default: _withCtx(() => [
            _createElementVNode("label", _hoisted_7, [
              _withDirectives(_createElementVNode("input", {
                name: "indicationsForPrenatalTesting",
                type: "radio",
                value: "3",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (_isRef(value) ? (value).value = $event : null))
              }, null, 512), [
                [_vModelRadio, _unref(value)]
              ]),
              _hoisted_8,
              _createTextVNode(" Stwierdzenie znacznie większego ryzyka urodzenia dziecka dotkniętego chorobą uwarunkowaną monogenetycznie lub wieloczynnikowo. ")
            ])
          ]),
          _: 1
        }),
        _createVNode(_unref(RadioGroupOption), {
          class: "cursor-pointer flex items-center justify-start font-medium text-[14px]",
          value: "Stwierdzenie w czasie ciąży nieprawidłowego wyniku badania USG lub badań biochemicznych wskazujących na zwiększone ryzyko abberacji chromosomowej lub wady płodu."
        }, {
          default: _withCtx(() => [
            _createElementVNode("label", _hoisted_9, [
              _withDirectives(_createElementVNode("input", {
                name: "indicationsForPrenatalTesting",
                type: "radio",
                value: "4",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (_isRef(value) ? (value).value = $event : null))
              }, null, 512), [
                [_vModelRadio, _unref(value)]
              ]),
              _hoisted_10,
              _createTextVNode(" Stwierdzenie w czasie ciąży nieprawidłowego wyniku badania USG lub badań biochemicznych wskazujących na zwiększone ryzyko abberacji chromosomowej lub wady płodu. ")
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    (_unref(errorMessage))
      ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(_unref(errorMessage)), 1))
      : _createCommentVNode("", true)
  ]))
}
}

}